import { UserRole, UserRoleView } from 'providence-types';

export const mapFromBackendToUserRole = (userRole: UserRole): UserRoleView => {
  const [key] = Object.entries(UserRole).find(
    ([, ur]: [string, string]) => ur === userRole,
  ) as [keyof typeof UserRoleView, string];

  return UserRoleView[key];
};
